<template>
  <div class="locale-changer">
    <div class="control has-icons-left has-text-centered">
      <div class="select" :class="selectStyle">
        <select v-model="$i18n.locale" @change="selectedLangOption">
          <option
            v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
            {{lang}}
          </option>
        </select>
        <span class="icon is-left">
          <i class="icon ion-md-globe"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['selectStyle'],
  data() {
    return {
      langs: ['en', 'nor'],
    };
  },

  methods: {
    selectedLangOption() {
      localStorage.setItem('appLang', this.$i18n.locale);
    },
  },
};
</script>
